export const REGEXES = {
  AMOUNT: /^\d*\.?\d{0,2}$/,
  UNICODE_WHITESPACE_CLEANER: /[\u0000-\u001F\u007F\u00A0\u1680\u180E\u2000-\u200F\u2028-\u202F\u205F\u2060\u3000\uFEFF]/g
};
